import { inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import {
  NavigationCallback,
  NavigationDropdown,
  NavigationExternalLink,
  NavigationItem,
  NavigationLink,
  NavigationSubheading,
} from './navigation-item.interface';
import { NavigationLoaderService } from './navigation-loader.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  public readonly items$: Observable<NavigationItem[]>;

  /** Emits the dropdown a user just toggled, so its siblings can close themselves (accordion). */
  public readonly openChange$: Observable<NavigationDropdown>;

  private readonly navigationLoaderService = inject(NavigationLoaderService);

  private readonly _openChange$ = new Subject<NavigationDropdown>();

  constructor() {
    this.items$ = this.navigationLoaderService.items$;
    this.openChange$ = this._openChange$.asObservable();
  }

  public triggerOpenChange(item: NavigationDropdown): void {
    this._openChange$.next(item);
  }

  public isLink(item: NavigationItem): item is NavigationLink {
    return item.type === 'link';
  }

  public isExternalLink(item: NavigationItem): item is NavigationExternalLink {
    return item.type === 'external-link';
  }

  public isDropdown(item: NavigationItem): item is NavigationDropdown {
    return item.type === 'dropdown';
  }

  public isSubheading(item: NavigationItem): item is NavigationSubheading {
    return item.type === 'subheading';
  }

  public isCallback(item: NavigationItem): item is NavigationCallback {
    return item.type === 'callback';
  }
}
